import React, { Component } from "react";
import {
  Button,
  Icon,
  Divider,
  Modal,
  Select,
  Popconfirm,
  message,
  Spin
} from "antd";
import { router } from "umi";
import { connect } from "dva";
import ListPage from "@/Components/ListPage";
import OperateDropdown from "@/components/OperateDropdown";
import styles from "./index.less";
import { GetQueryString } from "../../../../../utils/utils";

const { ListTable, ListCreate } = ListPage;

@connect(({ norm, createProject }) => ({
  active: norm.active,
  schoolList: norm.schoolList,
  pageInfo: norm.pageInfo,
  superviseList: createProject.superviseList,
  spinProps: norm.spinProps
}))
class index extends Component {
  constructor(props) {
    super(props);
    this.templateId = GetQueryString("currentNormId");
    this.state = {
      showModal: false,
      nowRespondentOrgName: "",
      nowRespondentOrgId: ""
    };
  }

  componentDidMount() {
    this.handleGetSchoolList();
  }

  // 获取学校列表
  handleGetSchoolList = pageInfo => {
    const { dispatch } = this.props;
    dispatch({
      type: "norm/fetchGetSchoolList",
      payload: {
        templateId: this.templateId,
        page: 1,
        pageSize: 10,
        ...pageInfo
      }
    });
  };

  // 开启个性化指标
  handleStartPersonal = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "norm/fetchStartPersonalNorm",
      payload: {
        templateId: this.templateId
      },
      callback: this.handleGetSchoolList
    });
  };

  // 展示新增学校modal
  handleShowModal = () => {
    const { dispatch } = this.props;
    this.setState({
      showModal: true
    });
    dispatch({
      type: "createProject/fetchGetSuperviseList"
    });
  };

  // 隐藏学校modal
  handleCloseModal = () => {
    this.setState({
      showModal: false
    });
  };

  // 添加学校
  handleAddSchool = () => {
    const { dispatch } = this.props;
    this.setState({
      showModal: false
    });
    const { nowRespondentOrgName, nowRespondentOrgId } = this.state;
    if (nowRespondentOrgId && nowRespondentOrgName) {
      dispatch({
        type: "norm/fetchAddSchool",
        payload: {
          respondentOrgId: nowRespondentOrgId,
          respondentOrgName: nowRespondentOrgName,
          templateId: this.templateId
        },
        callback: this.handleClearAddState
      });
    }
  };

  // 添加学校后清除
  handleClearAddState = () => {
    this.handleGetSchoolList();
    this.setState({
      nowRespondentOrgId: "",
      nowRespondentOrgName: ""
    });
  };

  // 下拉框选中学校
  handleSelectSchool = (value, option) => {
    const { key } = option;
    this.setState({
      nowRespondentOrgName: value,
      nowRespondentOrgId: key
    });
  };

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.handleGetSchoolList(pageInfo);
  };

  // 删除某个条目
  handleDelete = value => {
    const { dispatch } = this.props;
    const { respondentOrgId, respondentOrgName } = value;
    dispatch({
      type: "norm/fetchDeleteSchool",
      payload: {
        respondentOrgId,
        respondentOrgName,
        templateId: this.templateId
      },
      callback: this.handleGetSchoolList
    });
  };

  // 跳转页面
  routerJump = value => {
    const { respondentOrgId, respondentOrgName } = value;
    router.push(
      `/supervision/norm/management/settings/personalSettings?currentNormId=${this.templateId}&respondentOrgName=${respondentOrgName}&respondentOrgId=${respondentOrgId}`
    );
  };

  // 未启动页面
  renderNoStart = () => {
    return (
      <div className="noStartContainer">
        <div className="noStart">
          <div className="topPart">
            <div className="iconContainer">
              <Icon
                type="exclamation-circle"
                theme="filled"
                style={{ color: "#1785EC", fontSize: 29 }}
              />
            </div>
            <div>
              <div className="text">
                当前指标模板尚未启用个性化指标部分，点击按钮进行启用
              </div>
              <Button
                type="primary"
                style={{ marginTop: 18 }}
                onClick={this.handleStartPersonal}
              >
                启用个性化指标
              </Button>
            </div>
          </div>
          <Divider
            dashed
            style={{ border: "dashed rgba(0,0,0,0.1)", borderWidth: "1px 0 0" }}
          />
          <div className="bottomPart">
            <p>说明：</p>
            <p>启用个性化指标后，可在当前指标模板对指定学校配置个性化指标。</p>
          </div>
        </div>
      </div>
    );
  };

  // 表格部分
  renderTableContent = () => {
    const { schoolList, pageInfo } = this.props;
    const pageProps = {
      className: "personalNormTable",
      spinProps: {
        spinning: false
      }
    };

    const createProps = {
      btnText: "新增学校",
      onCreate: this.handleShowModal
    };

    const tableProps = {
      rowKey: "id",
      list: schoolList,
      pageInfo,
      onPageChange: this.handlePaginationChange,
      columns: [
        {
          title: "学校名称",
          dataIndex: "respondentOrgName",
          key: "respondentOrgName"
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          render: value => {
            const data = [
              {
                text: <a onClick={() => this.routerJump(value)}>指标设置</a>
              },
              {
                text: (
                  <Popconfirm
                    title="确认删除?"
                    onConfirm={() => {
                      this.handleDelete(value);
                    }}
                    okText="确定"
                    cancelText="取消"
                  >
                    删除
                  </Popconfirm>
                )
              }
            ];
            return <OperateDropdown data={data} />;
          }
        }
      ]
    };

    return (
      <ListPage {...pageProps}>
        <ListCreate {...createProps} />
        <ListTable {...tableProps} />
      </ListPage>
    );
  };

  // 弹框部分
  renderModal = () => {
    const { showModal } = this.state;
    const { superviseList } = this.props;

    const modalProps = {
      title: "新增学校",
      onCancel: this.handleCloseModal,
      visible: showModal,
      wrapClassName: "newSchoolContainer",
      onOk: this.handleAddSchool
    };

    const selectProps = {
      placeholder: "请选择",
      onChange: this.handleSelectSchool
    };

    return (
      <Modal {...modalProps}>
        <div className="selectContainer">
          <div className="schoolName">学校名称：</div>
          {showModal && (
            <Select {...selectProps}>
              {superviseList &&
                superviseList.map(item => {
                  return (
                    <Select.Option value={item?.orgName} key={item?.orgId}>
                      {item?.orgName}
                    </Select.Option>
                  );
                })}
            </Select>
          )}
        </div>
      </Modal>
    );
  };

  render() {
    const { active, spinProps } = this.props;
    return (
      <div className={styles.root}>
        {active === false && this.renderNoStart()}
        {active === true && this.renderTableContent()}
        {this.renderModal()}
      </div>
    );
  }
}

export default index;
